import { render, staticRenderFns } from "./Boat Berth.vue?vue&type=template&id=03dc8caa&"
import script from "./Boat Berth.vue?vue&type=script&lang=js&"
export * from "./Boat Berth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports